<template>
  <div>
      <div class="row">
        <div class='col-xl-12 col-lg-12'>
            <div class="card card-stats mb-4 mb-xl-0" style="background-color:#015249">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h6 class="card-title text-uppercase text-muted mb-0 text-white">Ranking Convênio Mês</h6>
                  <span class="h4 font-weight-bold mb-0 text-white">{{objetoCabecalho != undefined && objetoCabecalho.valor != undefined ? objetoCabecalho.valor : 0 | formatMoney}}</span>
                </div>
                <div class="col-auto">
                    <button type="button" class="btn btn-outline-ranking-convenio" @click="$emit('view-dashboard-repasse', true)"><li class="oi oi-action-undo"></li> VOLTAR</button>
                </div>
              </div>
              <p class="mt-3 mb-0 text-muted text-sm"> 
                <span :class="classLabelBadgeRankingConvenio"><i :class="iconClassBadgeRankingConvenio"></i>{{objetoCabecalho != undefined && objetoCabecalho.percentual_relacao_mes_anterior != undefined ? objetoCabecalho.percentual_relacao_mes_anterior : 0 | formatPercent}}  {{objetoCabecalho != undefined && objetoCabecalho.convenio != undefined ? objetoCabecalho.convenio : '' }}</span>
              </p>
            </div>
            </div>
        </div>
      </div>
      <div class="row">
        <div class='col-xl-12 col-lg-12'>
          <br/>
        </div>
      </div>
      <div class="row">
        <div class='col-xl-12 col-lg-12'>
          <br/>
        </div>
      </div>

      <transition name="view">
      <div class="row">
        <div class="col-xl-6 col-lg-12">
            <div class="card card-stats mb-4 mb-xl-0" style="background-color:#57BB90">
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <h6 class="card-title text-uppercase text-muted text-white">Serviços Recebidos Mês Por</h6>
                  </div>
                </div>
                
                <div class="row">

                  <div class="col-12">
                    <span class="h2 font-weight-bold mb-0 text-white">
                      <apexchart type=donut width="100%" :options="chartOptionsDonut" :series="seriesDonut" />
                    </span>
                  </div>
                  <div class="col-auto">
                    <div class="icon icon-shape bg-danger text-white rounded-circle shadow">
                      <i class="fas fa-chart-bar"></i>

                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 text-left mt-3 mb-0 text-muted text-sm">
                      <div class="btn-group" role="group" >
                        <button type="button" class="btn btn-sm text-white" :class="classBtnSelectedGroupBy('convenio')" @click="selectedGroupByDadosConvenio('convenio')">Convênio</button>
                        <button type="button" class="btn btn-sm text-white" :class="classBtnSelectedGroupBy('convenioHospital')" @click="selectedGroupByDadosConvenio('convenioHospital')">Convênio/Hospital</button>
                        <button type="button" class="btn btn-sm text-white" :class="classBtnSelectedGroupBy('entidadeConvenio')" @click="selectedGroupByDadosConvenio('entidadeConvenio')">Convênio/Entidade</button>
                        <button type="button" class="btn btn-sm text-white" :class="classBtnSelectedGroupBy('entidade')" @click="selectedGroupByDadosConvenio('entidade')">Entidade</button>
                      </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div class='col-xl-6 col-lg-12 table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl'>
            
            <table class="table align-items-center table-borderless table-hover table-sm table-md table-lg table-xl table-condensed" v-show="btnSelecionado == 'convenio'">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">%</th>
                      <th scope="col">Convênio</th>
                      <th scope="col">Mês Atual</th>
                      <th scope="col">Mês Anterior</th>
                      <th scope="col">Média Mensal</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(objeto) of listaConvenioCooperado" v-bind:key="objeto.convenio" 
                        @click="selectedSaldoDevedorEntidade(objeto)">
                      <td><span :class="classLabelBadgePercentualMesAnterior(objeto)"><i :class="iconClassBadgePercentualMesAnterior(objeto)"></i>{{objeto != undefined && objeto.percentual_relacao_mes_anterior != undefined ? objeto.percentual_relacao_mes_anterior : 0 | formatPercent}}</span></td>
                      <td>{{objeto.convenio}}</td>
                      <td>{{objeto.valor | formatMoney}}</td>
                      <td>{{objeto.valor_mes_anterior | formatMoney}}</td>
                      <td>{{objeto.valor_medio | formatMoney}}</td>
                    </tr>
                  </tbody>
              </table>  


            <table class="table align-items-center table-borderless table-hover table-sm table-md table-lg table-xl table-condensed" v-show="btnSelecionado == 'convenioHospital'">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">%</th>
                      <th scope="col">Convênio</th>
                      <th scope="col">Hospital</th>
                      <th scope="col">Mês Atual</th>
                      <th scope="col">Mês Anterior</th>
                      <th scope="col">Média Mensal</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(objeto) of listaHospitalCooperado" v-bind:key="`${objeto.convenio}/${objeto.hospital}`" 
                        @click="selectedSaldoDevedorEntidade(objeto)">
                      <td><span :class="classLabelBadgePercentualMesAnterior(objeto)"><i :class="iconClassBadgePercentualMesAnterior(objeto)"></i>{{objeto != undefined && objeto.percentual_relacao_mes_anterior != undefined ? objeto.percentual_relacao_mes_anterior : 0 | formatPercent}}</span></td>
                      <td>{{objeto.convenio}}</td>
                      <td>{{objeto.hospital}}</td>
                      <td>{{objeto.valor | formatMoney}}</td>
                      <td>{{objeto.valor_mes_anterior | formatMoney}}</td>
                      <td>{{objeto.valor_medio | formatMoney}}</td>
                    </tr>
                  </tbody>
              </table>


            <table class="table align-items-center table-borderless table-hover table-sm table-md table-lg table-xl table-condensed" v-show="btnSelecionado == 'entidade'">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">%</th>
                      <th scope="col">Entidade</th>
                      <th scope="col">Mês Atual</th>
                      <th scope="col">Mês Anterior</th>
                      <th scope="col">Média Mensal</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(objeto) of listaEntidadeCooperado" v-bind:key="objeto.pk_entidade_sasc" 
                        @click="selectedSaldoDevedorEntidade(objeto)">
                      <td><span :class="classLabelBadgePercentualMesAnterior(objeto)"><i :class="iconClassBadgePercentualMesAnterior(objeto)"></i>{{objeto != undefined && objeto.percentual_relacao_mes_anterior != undefined ? objeto.percentual_relacao_mes_anterior : 0 | formatPercent}}</span></td>
                      <td>{{objeto.entidade}}</td>
                      <td>{{objeto.valor | formatMoney}}</td>
                      <td>{{objeto.valor_mes_anterior | formatMoney}}</td>
                      <td>{{objeto.valor_medio | formatMoney}}</td>
                    </tr>
                  </tbody>
              </table>

              
            <table class="table align-items-center table-borderless table-hover table-sm table-md table-lg table-xl table-condensed" v-show="btnSelecionado == 'entidadeConvenio'">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col">%</th>
                      <th scope="col">Convênio</th>
                      <th scope="col">Entidade</th>
                      <th scope="col">Mês Atual</th>
                      <th scope="col">Mês Anterior</th>
                      <th scope="col">Média Mensal</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(objeto) of listaEntidadeConvenioCooperado" v-bind:key="`${objeto.convenio}/${objeto.entidade}`" >
                      <td><span :class="classLabelBadgePercentualMesAnterior(objeto)"><i :class="iconClassBadgePercentualMesAnterior(objeto)"></i>{{objeto != undefined && objeto.percentual_relacao_mes_anterior != undefined ? objeto.percentual_relacao_mes_anterior : 0 | formatPercent}}</span></td>
                      <td>{{objeto.convenio}}</td>
                      <td>{{objeto.entidade}}</td>
                      <td>{{objeto.valor | formatMoney}}</td>
                      <td>{{objeto.valor_mes_anterior | formatMoney}}</td>
                      <td>{{objeto.valor_medio | formatMoney}}</td>
                    </tr>
                  </tbody>
              </table>



          </div>

      </div>
      </transition>

      



    </div>
</template>

<script>
import http from "./../../../../axios";
import moment from 'moment'
import { mask } from "vue-the-mask";
moment.locale('pt-BR');
export default {
  name: "DemonstrativoRepasseRankingConvenioDetalhado",
  props: ['objetoCabecalho'],
  directives: { mask },
  created: function() {
    this.init();
  },
  updated: function(){
    
    if(this.cooperadoAnterior != this.tokens.id){
      this.getListaConvenioRanking();
      this.showDetalheEntidade = false;
      this.showDetalheEntidadeLancamento = false;
    }
  },
  methods: {
    init: function() {
      this.getTokens();
    },
    getTokens: function() {
      this.tokens = this.$cooperadowebapi.tokens.get("usuario");
    },
    tab: function(selecionado){
      this.tabSelecionado = selecionado;
    },
    selectedGroupByDadosConvenio: function(selecionado){
      this.btnSelecionado = selecionado;
      if(selecionado == "convenio"){
        if(this.listaConvenioCooperado == undefined || this.listaConvenioCooperado.length == 0){
          this.getListaConvenioRanking();
        }else{
            this.updatedGrafico(this.listaConvenioCooperado, "convenio");
        }
      }else{
        if(selecionado == "convenioHospital"){
           if(this.listaHospitalCooperado == undefined || this.listaHospitalCooperado.length == 0){
              this.getListaHospitalRanking();
           }else{
            this.updatedGrafico(this.listaHospitalCooperado, "convenioHospital");
           }
        }else{
          if(selecionado == "entidade"){
             if(this.listaEntidadeCooperado == undefined || this.listaEntidadeCooperado.length == 0){
                this.getListaEntidadeRanking();
             }else{
                this.updatedGrafico(this.listaEntidadeCooperado, "entidade");
             }
          }else{
            
            if(selecionado == "entidadeConvenio"){
              if(this.listaEntidadeConvenioCooperado == undefined || this.listaEntidadeConvenioCooperado.length == 0){
                  this.getListaEntidadeConvenioRanking();
              }else{
                  this.updatedGrafico(this.listaEntidadeConvenioCooperado, "entidadeConvenio");
              }
            }
          }
        }
      }
    },
    classBtnSelectedGroupBy: function(selecionado){
      return this.btnSelecionado != undefined && this.btnSelecionado == selecionado ? 
             'btn-secondary' : 'btn-outline-secondary';
    },

    classLabelBadgePercentualMesAnterior: function(objeto){
      return objeto != undefined &&
             objeto.percentual_relacao_mes_anterior != undefined && 
             objeto.percentual_relacao_mes_anterior < 0 ? 
             'badge badge-mod-danger' : 'badge badge-mod-success';
    },
    iconClassBadgePercentualMesAnterior: function(objeto){
      return objeto != undefined && 
             objeto.percentual_relacao_mes_anterior != undefined && 
             objeto.percentual_relacao_mes_anterior < 0 ? 
             'oi oi-arrow-bottom' : 'oi oi-arrow-top';
    },
    selectConvenioLancamentoRepasse: function(convenio, lancamentoRepasse){
      this.filterList.convenio = convenio;
      this.filterList.lancamento = lancamentoRepasse;
      this.tab("servicosRecebidos")
    },
    selectedSaldoDevedorEntidade: function(objeto){
      this.saldoDevedorSelecionado = objeto;
      if(this.saldoDevedorSelecionado != undefined){
        this.tabSelecionado = "saldoDevedorEntidadeLancamento";
        this.showDetalheEntidade = true;
        this.showDetalheEntidadeLancamento = false;
        this.getLancamentoEntidadeSaldoDevedor();
      }
    },
    selectedSaldoDevedorEntidadeLancamento: function(objeto){
      this.lancamentoSaldoDevedorSelecionado = objeto;
      if(this.lancamentoSaldoDevedorSelecionado != undefined){
        this.tabSelecionado = "saldoDevedorEntidadeLancamentoDetalhe";
        this.showDetalheEntidadeLancamento = true;
        this.getDetalheLancamentoEntidadeSaldoDevedor();
      }
    },
    updatedGrafico: function(lista, tipo){
      var labels = [];
            this.seriesDonut = [];
            var totalOutros = 0;
            if(lista != undefined && lista.length > 0){
              for(var i=0; i < lista.length; i++){
                if(i < 4){
                  if(tipo == "convenio"){
                    labels.push(lista[i].convenio)
                  }else{
                    if(tipo == "entidade"){
                      labels.push(lista[i].entidade)
                    }else{
                      if(tipo == "convenioHospital"){
                        labels.push(`${lista[i].convenio}/${lista[i].hospital}`)
                      }else{
                        if(tipo == "entidadeConvenio"){
                          labels.push(`${lista[i].convenio}/${lista[i].entidade}`)
                        }
                      }
                    }
                  }
                  this.seriesDonut.push(lista[i].valor)
                }else{
                  if(i == 4){
                    labels.push("Outros")
                  }
                  totalOutros+=lista[i].valor;
                }
              }
              if(totalOutros > 0){
                this.seriesDonut.push(totalOutros)
              }
            }else{

            }

            this.chartOptionsDonut = {            
          chart: {
              type: 'donut'
            },
            dataLabels: {
              enabled: true
            },
          plotOptions: {
            pie: {
              expandOnClick: false
            }
          },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }],
            legend: {
              position: 'right',
              offsetY: 0,
              height: 230,
            },
          labels: labels
        };
    },
   getListaConvenioRanking: function() {
      this.$Progress.start();
      http
        .get(`api/repasse/cooperado/${this.tokens.id}/servicosrecebidos/totalizado/convenio/lista`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {
            this.listaConvenioCooperado = r.data.result;
            this.updatedGrafico(this.listaConvenioCooperado, "convenio");
            



            this.cooperadoAnterior = this.tokens.id;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.$Progress.fail();
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    },
   getListaHospitalRanking: function() {
      this.$Progress.start();
      http
        .get(`api/repasse/cooperado/${this.tokens.id}/servicosrecebidos/totalizado/hospital/lista`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {
            this.listaHospitalCooperado = r.data.result;
            
            this.updatedGrafico(this.listaHospitalCooperado, "convenioHospital");
            this.cooperadoAnterior = this.tokens.id;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.$Progress.fail();
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    },
   getListaEntidadeRanking: function() {
      this.$Progress.start();
      http
        .get(`api/repasse/cooperado/${this.tokens.id}/servicosrecebidos/totalizado/entidade/lista`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {
            this.listaEntidadeCooperado = r.data.result;
            
            this.updatedGrafico(this.listaEntidadeCooperado, "entidade");
            this.cooperadoAnterior = this.tokens.id;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.$Progress.fail();
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    },
   getListaEntidadeConvenioRanking: function() {
      this.$Progress.start();
      http
        .get(`api/repasse/cooperado/${this.tokens.id}/servicosrecebidos/totalizado/entidadeconvenio/lista`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {
            this.listaEntidadeConvenioCooperado = r.data.result;
            
            this.updatedGrafico(this.listaEntidadeConvenioCooperado, "entidadeConvenio");
            this.cooperadoAnterior = this.tokens.id;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.$Progress.fail();
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    },
   getLancamentoEntidadeSaldoDevedor: function() {
      this.totalDevidoLancamento = 0;
      this.$Progress.start();
      http
        .get(`api/saldodevedor/cooperado/19326/entidade/${this.saldoDevedorSelecionado.pk_entidade_sasc}/lista`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {

            this.listaConvenioCooperadoLancamentoEntidade = r.data.result;
            this.entidadeAnterior = this.saldoDevedorSelecionado.pk_entidade_sasc;

            if(this.listaConvenioCooperadoLancamentoEntidade != undefined && this.listaConvenioCooperadoLancamentoEntidade.length > 0){
              for(var i=0; i < this.listaConvenioCooperadoLancamentoEntidade.length; i++){
                this.totalDevidoLancamento = this.totalDevidoLancamento + this.listaConvenioCooperadoLancamentoEntidade[i].valor_devido;
              }

            }else{
              this.totalDevidoLancamento = 0;
            }


          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.$Progress.fail();
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    },
   getDetalheLancamentoEntidadeSaldoDevedor: function() {
      this.totalDevidoLancamentoDetalhe = 0;
      this.totalInicioLancamentoDetalhe = 0;
      this.totalPagoLancamentoDetalhe = 0;
      this.$Progress.start();

      http
        .get(`api/saldodevedor/cooperado/${this.tokens.id}/entidade/${this.lancamentoSaldoDevedorSelecionado.pk_entidade_sasc}/lancamento/${this.lancamentoSaldoDevedorSelecionado.pk_lancamento_repasse_sasc}/lista`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {
            this.listaConvenioCooperadoLancamentoEntidadeDetalhe = r.data.result;
            this.entidadeLancamentoAnterior = `${this.lancamentoSaldoDevedorSelecionado.pk_entidade_sasc} - ${this.lancamentoSaldoDevedorSelecionado.pk_lancamento_repasse_sasc}`;

            if(this.listaConvenioCooperadoLancamentoEntidadeDetalhe != undefined && this.listaConvenioCooperadoLancamentoEntidadeDetalhe.length > 0){
              for(var i=0; i < this.listaConvenioCooperadoLancamentoEntidadeDetalhe.length; i++){
                this.totalDevidoLancamentoDetalhe = this.totalDevidoLancamentoDetalhe + this.listaConvenioCooperadoLancamentoEntidadeDetalhe[i].valor_devido;
                this.totalInicioLancamentoDetalhe = this.totalInicioLancamentoDetalhe + this.listaConvenioCooperadoLancamentoEntidadeDetalhe[i].valor_inicio;
                this.totalPagoLancamentoDetalhe = this.totalPagoLancamentoDetalhe + this.listaConvenioCooperadoLancamentoEntidadeDetalhe[i].valor_pago;
              }

            }else{
              this.totalDevidoLancamentoDetalhe = 0;
              this.totalInicioLancamentoDetalhe = 0;
              this.totalPagoLancamentoDetalhe = 0;
            }


          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.$Progress.fail();
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    }
  },
  data: function() {
    return {    
      listaConvenioCooperadoLancamentoEntidade: undefined,
      listaConvenioCooperadoLancamentoEntidadeDetalhe: undefined,
      totalDevidoLancamento: 0,
      totalDevidoLancamentoDetalhe: 0,
      totalInicioLancamentoDetalhe: 0,
      totalPagoLancamentoDetalhe: 0,
      entidadeAnterior: "",
      entidadeLancamentoAnterior: "",
      listaConvenioCooperado: undefined,
      listaHospitalCooperado: undefined,
      listaEntidadeCooperado: undefined,
      listaEntidadeConvenioCooperado: undefined,
      btnSelecionado: "convenio",
      totalSaldoDevedor: 0,
      cooperadoAnterior: "",
      saldoDevedorSelecionado: undefined,
      lancamentoSaldoDevedorSelecionado: undefined,
      showDetalheEntidade: false,
      showDetalheEntidadeLancamento: false,
      tabSelecionado: "graficoServicosRecebidos",
      tokens: {},
      chartOptions: {
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },


          xaxis: {
            type: 'datetime',
            categories: ["2018-09-19T00:00:00", "2018-09-19T01:30:00", "2018-09-19T02:30:00",
              "2018-09-19T03:30:00", "2018-09-19T04:30:00", "2018-09-19T05:30:00",
              "2018-09-19T06:30:00"
            ],
          },
          tooltip: {
            x: {
              format: 'dd/MM/yy HH:mm'
            },

          }
        },

        series: [{
          name: 'series1',
          data: [31, 40, 28, 51, 42, 109, 100]
        }, {
          name: 'series2',
          data: [11, 32, 45, 32, 34, 52, 41]
        }],

        seriesDonut: [],
        chartOptionsDonut: {            
          chart: {
              type: 'donut'
            },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }],
            legend: {
              position: 'right',
              offsetY: 0,
              height: 230,
            },
          labels: []
        }
    };
  },
  computed: {
    
    classLabelBadgeRankingConvenio: function(){
      return this.objetoCabecalho != undefined &&
             this.objetoCabecalho.percentual_relacao_mes_anterior != undefined && 
             this.objetoCabecalho.percentual_relacao_mes_anterior < 0 ? 
             'badge badge-mod-danger' : 'badge badge-mod-success';
    },
    iconClassBadgeRankingConvenio: function(){
      return this.objetoCabecalho != undefined && 
             this.objetoCabecalho.percentual_relacao_mes_anterior != undefined && 
             this.objetoCabecalho.percentual_relacao_mes_anterior < 0 ? 
             'oi oi-arrow-bottom' : 'oi oi-arrow-top';
    },
    filteredServicosRecebidosAtendimento:function() {
      const { filterList, listaServicosRecebidosAtendimento} = this

      var lista = this.listaServicosRecebidosAtendimento
        .filter(objeto => String(objeto.ano_atendimento).toLowerCase().indexOf(filterList.ano.toLowerCase()) > -1)
        .filter(objeto => objeto.atendimento.toLowerCase().indexOf(filterList.atendimento.toLowerCase()) > -1)
        .filter(objeto => objeto.hospital.toLowerCase().indexOf(filterList.hospital.toLowerCase()) > -1)
        .filter(objeto => objeto.convenio.toLowerCase().indexOf(filterList.convenio.toLowerCase()) > -1)
        .filter(objeto => objeto.acomodacao.toLowerCase().indexOf(filterList.acomodacao.toLowerCase()) > -1)
        .filter(objeto => objeto.paciente.toLowerCase().indexOf(filterList.paciente.toLowerCase()) > -1)
        .filter(objeto => objeto.codigo_procedimento.toLowerCase().indexOf(filterList.procedimento.toLowerCase()) > -1)
        .filter(objeto => Vue.filter("formatDate")(objeto.data_realizacao).toLowerCase().indexOf(filterList.realizacao.toLowerCase()) > -1)
        .filter(objeto => objeto.descricao_lancamento_repasse.toLowerCase().indexOf(filterList.lancamento.toLowerCase()) > -1)
        .filter(objeto => filterList.valor == 0 || (filterList.valor > 0 && objeto.valor_lancamento == filterList.valor));

        this.totalServicosRecebidoAtendimento = 0;

        for(var i=0; i < lista.length; i++){
            this.totalServicosRecebidoAtendimento = lista[i].credito ? 
                                                              this.totalServicosRecebidoAtendimento + lista[i].valor_lancamento : 
                                                            lista[i].debito ? 
                                                              this.totalServicosRecebidoAtendimento - lista[i].valor_lancamento : 
                                                            this.totalServicosRecebidoAtendimento;
        }

      return lista;
    },

  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/demonstrativo/repasse/DemonstrativoRepasseRankingConvenioDetalhado.vue